import { inject, Injectable } from '@angular/core';
import { AuthService } from 'src/app/auth/services/auth.service';
import { TokenClaims } from '../interfaces/token-claims.interface';

export interface IUserData {
    aud: string;
    company?: string;
    country?: string;
    exp: number;
    given_name: string;
    iat: number;
    iss: string;
    family_name: string;
    email: string;
    nickname: string;
    nonce: string;
    orgCode: string;
    gid: string;
}

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private authService = inject(AuthService);

    public getIDTokenUserData(): IUserData | null {
        const decodedToken = this.authService.userIdTokenClaims() as TokenClaims;
        if (!decodedToken) {
            return null;
        }
        return {
            aud: decodedToken.aud || '',
            company: decodedToken.company_unit || '',
            country: decodedToken.country || '',
            exp: decodedToken.exp || 0,
            given_name: decodedToken.given_name || '',
            iat: decodedToken.iat || 0,
            iss: decodedToken.iss || '',
            family_name: decodedToken.family_name || '',
            email: decodedToken.mail || '',
            nickname: decodedToken.preferred_given_name || '',
            nonce: decodedToken.nonce || '',
            orgCode: decodedToken.org_code || '',
            gid: decodedToken.gid || ''
        };
    }
}
